<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">{{ this.pageName }}</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">Settings</li>
                            <li class="breadcrumb-item active">{{ this.pageName }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>{{ this.pageName }}</h4>
                </div>
                <div class="card-body">
                    <section class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Giftcard Minimum Purchase</label>
                                        <input type="number" required class="form-control"
                                               v-model="configuration.giftcard_minimum_purchase">
                                        <span v-if="configuration.errors.giftcard_minimum_purchase"
                                              class="text-danger text-small">{{
                                                configuration.errors.giftcard_minimum_purchase
                                            }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Giftcard Maximum Purchase</label>
                                        <input type="number" required class="form-control"
                                               v-model="configuration.giftcard_maximum_purchase">
                                        <span v-if="configuration.errors.giftcard_maximum_purchase"
                                              class="text-danger text-small">{{
                                                configuration.errors.giftcard_maximum_purchase
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary" @click="updateGiftcardSettings">
                                    Update
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import QuillEditor from '../../Shared/QuillEditor';
import GalleryModal from "@/Shared/GalleryModal";

export default {
    metaInfo: {title: 'Configurations'},
    props: [
        'configurations',
        'configurationEnums',
        'pageName',
        'routeName',
    ],
    layout: Layout,
    name: 'ConfigurationIndex',
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            saving: false,
            configuration: this.$inertia.form({
                giftcard_minimum_purchase: null,
                giftcard_maximum_purchase: null,
            }),
        };
    },
    mounted() {
        this.configuration.giftcard_minimum_purchase = this.configurations.giftcard_minimum_purchase;
        this.configuration.giftcard_maximum_purchase = this.configurations.giftcard_maximum_purchase;
    },

    methods: {
        async updateGiftcardSettings() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                }
            };

            this.configuration.post(route(this.routeName), options);
            this.saving = false;
        },
    }
}
</script>
